import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=6d96c4a3&scoped=true&"
import script from "./Space.vue?vue&type=script&lang=js&"
export * from "./Space.vue?vue&type=script&lang=js&"
import style0 from "./Space.vue?vue&type=style&index=0&id=6d96c4a3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96c4a3",
  null
  
)

export default component.exports